import { render, staticRenderFns } from "./WorkspaceCfdeGeneSetsTable.vue?vue&type=template&id=1e1cb6bc&scoped=true"
import script from "./WorkspaceCfdeGeneSetsTable.vue?vue&type=script&lang=js"
export * from "./WorkspaceCfdeGeneSetsTable.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceCfdeGeneSetsTable.vue?vue&type=style&index=0&id=1e1cb6bc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1cb6bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e1cb6bc')) {
      api.createRecord('1e1cb6bc', component.options)
    } else {
      api.reload('1e1cb6bc', component.options)
    }
    module.hot.accept("./WorkspaceCfdeGeneSetsTable.vue?vue&type=template&id=1e1cb6bc&scoped=true", function () {
      api.rerender('1e1cb6bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceCfdeGeneSetsTable.vue"
export default component.exports